<template>
  <div
    class="input-text-button"
    :class="{error:error}"
  >
    <i
      :class="leadingIcon"
      class="leading-icon"
    />
    <input
      :value="value"
      type="text"
      :disabled="disabled"
      :placeholder="placeholder"
      :maxlength="textLength"
      :class="{icon:leadingIcon}"
      @input="changeValue($event)"
    >
  </div>
</template>
<script>
export default {
  name: "IuputTextButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    textLength: {
      type: String,
      default: ""
    },
    leadingIcon: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeValue(e) {
      this.$emit("input", e.target.value);
    }
  }
};
</script>
<style lang="scss" scoped>
.input-text-button {
  position: relative;
  width: 100%;
  &.error {
    .leading-icon {
      color: var(--red-500);
    }
    input {
      border: solid 1px var(--red-500);
      background-color: rgba(206, 56, 41, 0.1);
      color: var(--red-500);
    }
  }
  .leading-icon {
    position: absolute;
    top: 12px;
    left: 16px;
    font-size: 24px;
    color: var(--gray-900);
  }
  input {
    @include ts;
    padding: 11px 20px;
    width: 100%;
    background-color: transparent;
    border-radius: 10px;
    border: solid 1px var(--gray-300);
    font-size: 1rem;
    line-height: 1.38;
    letter-spacing: 1px;
    color: var(--gray-900);
    &.icon {
      padding: 11px 20px 11px 48px;
    }
    &::placeholder {
      color: var(--gray-700);
    }
    &:focus {
      border: solid 1px var(--blue-500);
      background-color: var(--white);
    }
    &:disabled {
      background-color: #f5f5f5;
    }
  }
}
</style>